import {course_class_getCourseClassTimetables_Api} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose, withProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import CourseClassInformation from 'views/AppLocals/Course/CourseClass/CourseClassInformation'
import useCourseClassTimetable from 'views/AppLocals/Course/CourseClass/useCourseClassTimetable'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault, renderTrue} from 'views/Shared'
import CouseClassTimetableFilter from '../components/filters/CouseClassTimetableFilter'
import {renderCourseClassTeacherAssignment} from '../functions/renderCourseClassTimetable'
import {useRouteSearchParam} from "../../../../envs/_current/history";

const TimetableManager = ({
                            owner_id,
                            owner_type,
                            filter_option = renderTrue,
                            filter_actions = {
                              sortBy: 'sort-by',
                              keyword: 'keyword',
                              course_id: 'course-id',
                              subject_id: 'subject-id',
                              course_class_id: 'class-id',
                              to_time_open: 'to-date',
                              from_time_open: 'from-date',
                              status: 'status'
                            },
                            ...props
                          }) => {
  const t = useTranslate()

  const location = useLocation()

  const {isSm} = useContext(LayoutContext)

  const sortBy = useRouteSearchParam(filter_actions.sortBy)

  const course_id = useRouteSearchParam(filter_actions.course_id)

  const status = useRouteSearchParam(filter_actions.status)

  const subject_id = useRouteSearchParam(filter_actions.subject_id)

  const to_time_open = useRouteSearchParam(filter_actions.to_time_open)

  const from_time_open = useRouteSearchParam(filter_actions.from_time_open)

  const course_class_id = useRouteSearchParam(filter_actions.course_class_id)

  const {
    modal,
    refreshKey,
    renderContextMenu,
    handleAction = NullAsDefault,
  } = useCourseClassTimetable({
    Header: CourseClassInformation,
  })

  const refresh_deps = useMemo(
    () => [
      owner_id,
      owner_type,
      refreshKey,
      `refreshToken=${_.get(location.state, 'refreshToken')}`,
    ],
    [owner_id, owner_type, refreshKey, location.state]
  )

  const [pager_widget] = usePaginationHelper({
    filter_params: {
      owner_id,
      owner_type,
    },
    onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
      onFilterChange({
        course_id,
        subject_id,
        to_time_open,
        from_time_open,
        course_class_id,
        status
      })
      onSortChange(sortBy)
    },
    pagerInfo: {
      RenderEntity: React.Fragment,
      renderItem: renderCourseClassTeacherAssignment({
        renderContextMenu,
      }),
      apiInfo: course_class_getCourseClassTimetables_Api,
      query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
      ...props,
    },
    SortByWidget: NullAsDefault,
    renderSortBy: NullAsDefault,
    isToggleDefault: true,
    query_params: filter_actions,
    dependencies: [owner_id, owner_type],
    withKey: createPagerKey(refresh_deps),
    AdvancedFilter: CouseClassTimetableFilter,
  })
  return (
    <div className="flex flex-1 flex-col space-y-3">
      <AdvancedHeader title={!isSm && 'timetables'}/>
      {pager_widget}
      {modal}
    </div>
  )
}

const AdvancedHeader = withProps({
  description:
    'This section displays the entire timetable filtered by class and subject for administrators to track the daily teaching schedule.',
})(ListHeader)

const CourseClassTimetable = compose(
  branch(
    ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
    () => () => <ContentNotFound/>
  )
)(TimetableManager)

export default CourseClassTimetable
